
import * as PropTypes from 'prop-types';
import { useLocalization } from '@progress/kendo-react-intl';
import logo from '../assets/logo_footer.png';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { AccessToken } from '../config/AccessToken';
import { InteractionRequiredAuthError } from '@azure/msal-browser';


export const Footer = () => {
    const localizationService = useLocalization();
    let languageId = localStorage.getItem('languageId');
    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const [instance, accessTokenRequest] = AccessToken();

    const getCurrentTime = () => {
        var currentdate = new Date(); 
        var datetime = currentdate.getDate() + "/"
                    + (currentdate.getMonth()+1).toString().padStart(2, "0")  + "/" 
                    + currentdate.getFullYear() + " - "  
                    + currentdate.getHours().toString().padStart(2, "0") + ":"  
                    + currentdate.getMinutes().toString().padStart(2, "0") + ":" 
                    + currentdate.getSeconds().toString().padStart(2, "0");

        return datetime;
    }

    const [dateTime, setDateTime] = useState<any>(getCurrentTime());

    const [imageLogo, setImageLogo] = useState<any>(null);

    useEffect(() => {
        setTimeout(() => {
            setDateTime(getCurrentTime())
        }, 1000)
    })                

    const getImageLogo = async () => {

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/account/logo`, { headers })
            .then((res) => {
                const image =  `data:image/png;base64, ${res?.data?.data.image}`
                setImageLogo(image);
            }).catch(() => {
                
            });
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }

    useEffect(() => {
        getImageLogo();
    }, [])

    return (
        // <header className="header" style={{ backgroundImage: `url(${headerBg})` }}>
        <div className="footer">

            <div className="title">
                {/*<p style={{width: '92%', height: '30px', padding: '10px'}} >{localizationService.toLanguageString('footer_updated','NOT FOUND')}{dateTime}</p>*/}
                <img src={imageLogo} style={{height: '50px', padding:'2px', marginRight: '10px'}} />
                <img src={logo} alt={'locator'} style={{width: '150px', height: '50px', marginRight: '10px'}} />
            </div>                
                
            {/* <Avatar type={'image'}>
            </Avatar> */}

        </div>
    );
}

Footer.displayName = 'Footer';
Footer.propTypes = {
    page: PropTypes.string,
    onButtonClick: PropTypes.func,
    changeTheme: PropTypes.func,
    theme: PropTypes.string,
};
